(function () {
    "use strict";

    angular.module("app").component("habilFilePicker", {
        transclude: true,
        bindings: {
            fileType: "@",
            onFileSelected: "&",
            allowMultiple: "=?",
            allowExtensions: "@",
            buttonClass: "@"
        },
        templateUrl: "@/upload/filePicker.html",
        controller: FilePickerController
    });

    FilePickerController.$inject = ["$scope", "controllerDecorator", "FileUploaderFactory"];
    function FilePickerController($scope, controllerDecorator, FileUploaderFactory) {
        const $controller = this;

        controllerDecorator.Decorate($controller, []);

        const privateStore = { Attachments: [] };

        /**
         * Invokes the onUploaded callback
         */
        function executeCallback() {
            if (privateStore.Attachments.length === 0)
                return;

            try {
                if (!angular.isFunction($controller.onFileSelected))
                    return;

                $controller.onFileSelected({ attachments: privateStore.Attachments });
            }
            finally {
                privateStore.Attachments = [];
            }
        };

        $scope.fileUploader = FileUploaderFactory.CreateFileUploader(null, {
            onSuccessItem: (_f, attachment) => {
                attachment.TypeCode = $controller.fileType;
                privateStore.Attachments.push(attachment);

                $("input[type=file][nv-file-select]").val("");
            },
            onErrorItem: onErrorItem,
            onCompleteAll: executeCallback
        });

        $controller.$onInit = function () {
            $scope.fileUploader.queueLimit = $controller.allowMultiple ? 10 : 1;

            if (angular.isString($controller.allowExtensions)) {
                FileUploaderFactory.AddExtensionFilter($scope.fileUploader, $controller.allowExtensions.toLowerCase().replace(/\./g, "").split(","));
            }
            else {
                $controller.allowExtensions = ".pdf";
            }
        };

        function onErrorItem(fileItem, _response, _status, _headers) {
            $controller.ShowError(getErrorMessage(fileItem?.error));

            function getErrorMessage(error) {
                const baseMessage = $controller.getTranslation("Shared_Something_Went_Wrong");
                if (!error || !error.name)
                    return baseMessage;

                return `${baseMessage} [${error.name}]`;
            }
        };
    };
})();